import images from "./images";
export const slides = [
  {
    image: images.puppy_with_woman,
    title: "But I must explain to you how all this mistaken idea of...",
    content:
      "But I must explain to you how all this mistaken idea of denouncing pleasure...",
  },
  {
    image: images.horse_with_woman,
    title: "But I must explain to you how all this mistaken idea of...",
    content:
      "But I must explain to you how all this mistaken idea of denouncing pleasure...",
  },
  {
    image: images.puppy,
    title: "But I must explain to you how all this mistaken idea of...",
    content:
      "But I must explain to you how all this mistaken idea of denouncing pleasure...",
  },
];
